import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { WinesProvider } from '@/contexts/WinesContext';
import { PrivateRoute, PublicRoute } from '@/components/routing';
import { ScrollToTop } from '@/components/ScrollToTop';
import { InstallPrompt } from '@/components/InstallPrompt';
import { UpdatePrompt } from '@/components/UpdatePrompt';

// Public Pages
import { LoginPage } from '@/pages/LoginPage';
import { SetupPasswordPage } from '@/pages/SetupPasswordPage';

// User Pages
import {
  HomePage,
  AddWinePage,
  WineDetailPage,
  StatsPage,
  ProfilePage,
} from '@/pages/user';

// Admin Pages
import {
  AdminDashboard,
  UserManagement,
  AuditLogsPage,
} from '@/pages/admin';

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ScrollToTop />
      <AuthProvider>
        <WinesProvider>
          <InstallPrompt />
          <UpdatePrompt />
          <Routes>
            {/* Public Routes */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route path="/setup-password" element={<SetupPasswordPage />} />

            {/* User Routes - Protected */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/add"
              element={
                <PrivateRoute>
                  <AddWinePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/edit/:id"
              element={
                <PrivateRoute>
                  <AddWinePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/wine/:id"
              element={
                <PrivateRoute>
                  <WineDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/stats"
              element={
                <PrivateRoute>
                  <StatsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              }
            />

            {/* Admin Routes - Protected & Require Admin Role */}
            <Route
              path="/admin"
              element={
                <PrivateRoute requireAdmin>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <PrivateRoute requireAdmin>
                  <UserManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/audit"
              element={
                <PrivateRoute requireAdmin>
                  <AuditLogsPage />
                </PrivateRoute>
              }
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </WinesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
